import { render, staticRenderFns } from "./Formater.vue?vue&type=template&id=53a5adef"
import script from "./Formater.vue?vue&type=script&lang=js"
export * from "./Formater.vue?vue&type=script&lang=js"
import style0 from "./Formater.vue?vue&type=style&index=0&id=53a5adef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports